import React, { FunctionComponent, memo, useContext } from 'react'
import { User } from '../../../../responses/users'
import FieldHints from '../../dropdowns/FieldHints/FieldHints'
import { unit } from '../../../../utils/utils'
import UserPanel from '../../elements/UserElement/UserElement'
import clsx from 'clsx'
import styles from './UserPicker.module.sass'
import Ellipsis from '../../../etc/Ellipsis/Ellipsis'
import { getId } from '../../../../utils/entity-utils'
import { userRenderer } from '../../../../utils/renderers'
import PlusIcon from 'files/plus.svg'
import { inactiveContext } from '../../../../constants/contexts'

interface Props {
    className?: string,
    data: User[],
    user?: User | null,
    text: string,
    title: string
    disabled?: boolean,
    minimal?: boolean,
    warning?: boolean,
    onlyIcon?: boolean,
    onClick: (user: User) => void,
    onChange?: (search: string, reset: boolean) => void,
}

const UserPicker: FunctionComponent<Props> = (props: Props) => {
    const hidden = useContext(inactiveContext)
    const disabled = props.disabled || hidden

    return <FieldHints
        data={props.data}
        selected={unit(props.user)}
        toKey={getId}
        render={userRenderer}
        onChange={props.onChange}
        onClick={props.onClick}
    >
        {
            ({ toggle, isOpen }) => <div className={clsx(props.className, styles.container)}>{
                props.user ? <UserPanel
                        className={styles.panel}
                        disabled={disabled}
                        user={props.user}
                        onClick={toggle}
                        onlyIcon={props.onlyIcon}
                    >
                        {
                            (!disabled && !props.onlyIcon) && <div className={styles.title}>{props.title}</div>
                        }
                    </UserPanel> :
                    !disabled && <div
                        className={clsx(styles.empty, {
                            [styles.active]: isOpen,
                            [styles.minimal]: props.minimal,
                            [styles.warning]: props.warning,
                        })}
                        onClick={toggle}
                    >
                        <div className={styles.icon}>
                            <PlusIcon/>
                        </div>
                        {
                            !props.onlyIcon && <Ellipsis className={styles.text}>
                                {props.text}
                            </Ellipsis>
                        }
                    </div>
            }
            </div>
        }
    </FieldHints>
}

export default memo(UserPicker)